import React from 'react';
import { useEmailVerificationSuccessNotifier } from '@apps/common/hooks/useEmailVerificationSuccessNotifier';
import { Confetti } from '../Confetti';

export const EmailVerificationConfirmation = () => {
  const { showSuccessEffect } = useEmailVerificationSuccessNotifier();

  return showSuccessEffect ? <Confetti /> : <></>;
};

EmailVerificationConfirmation.displayName = 'EmailVerificationConfirmation';
